import { DEFAULT_NOTE_COLOR } from "../../constants";

import type { NoteEditorData } from "../noteEditorModal/NoteEditorModal";

/**
 * Creates a storage key for drafts.
 */
export function createStorageKey(id: string) {
  return `note:${id}`;
}

/**
 * Retrieve draft data from local storage
 */
export function getDraftData(id: string) {
  const data = globalThis.localStorage?.getItem(id);
  return data ? (JSON.parse(data) as NoteEditorData) : null;
}

/**
 * Save the draft data to local storage
 */
export function setDraftData(id: string, data: Partial<NoteEditorData>) {
  const mergedData: NoteEditorData = Object.assign(
    { color: DEFAULT_NOTE_COLOR, value: "" },
    data,
  );
  globalThis.localStorage?.setItem(id, JSON.stringify(mergedData));
  return mergedData;
}

/**
 * Remove the draft data from local storage
 */
export function clearDraftData(id: string) {
  globalThis.localStorage?.removeItem(id);
}
